import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 6v2.877l1 1V3.5c0-.827-.673-1.5-1.5-1.5h-5a1.48 1.48 0 00-.995.383L9.123 6H12zm.973 5.264l-2.237-2.237L7.708 6 5.02 3.31 3.707 2l-.706.707 1.999 2v5.571A1.979 1.979 0 004 10c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2V5.706l3.748 3.747A1.99 1.99 0 009 11c0 1.103.897 2 2 2a1.99 1.99 0 001.547-.748l1.746 1.747.708-.707-2.028-2.028z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.49 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 18v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.448 4.448 0 00-2.984 1.148L27.37 18H36zm2.92 15.793l-6.712-6.712h-.002l-9.08-9.08h.002l-8.07-8.07-3.936-3.934-2.12 2.12 5.998 6v16.718c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.69-6 6 0 3.308 2.692 6 6 6s6-2.692 6-6V17.117L29.244 28.36C27.886 29.461 27 31.121 27 33.001c0 3.308 2.692 6 6 6 1.88 0 3.54-.888 4.64-2.246l5.24 5.242 2.122-2.122-6.082-6.082z",
    clipRule: "evenodd"
  }))
};
export var MusicNoneFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});